import { Component } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-data-security',
    templateUrl: 'data-security.component.html',
    styleUrls: ['../pages.scss'],
})

export class DataSecurityComponent  {
    activeLanguage = 'german';
    constructor(private ls: LanguageService) {
        ls.getLanguage().subscribe(val => this.activeLanguage = val);
    }
    content = {
        german: `<div class="row margin-below">
        <div class="col">
            <h1 class="header">Impressum</h1>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <p>Impressum kommt bald.</p>
        </div>
    </div>`,
      english: `<div class="row margin-below">
      <div class="col">
          <h1 class="header">Imprint</h1>
      </div>
  </div>
  <div class="row">
      <div class="col">
          <p>Imprint follows soon.</p>
      </div>
  </div>
    `,
    };
}



// WEBPACK FOOTER //
// ./src/app/components/data-security/data-security.component.ts